export default {"src":"/_next/static/media/gift_64.967502b3.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};